namespace Dashboard {

    type Passenger = Core.ManageBooking.Passenger;

    export interface PassengerInfo {
        PassengerId: number;
        Name: string;
        DocumentNumber: string;
        Nationality: string;
        DocumentIssuingCountry: string;
        CountryOfBirth: string;
        DocumentType: number;
        DateOfBirth: string;
        DocumentIssuedDate: string;
        DocumentExpiryDate: string;
        DetailsSubmitted: boolean;
    }

    export interface IAddAPIService {
        addAPI(bookingId:number, passengers: PassengerInfo[]);
        getPassengerInfo(bookingId: number): ng.IPromise<PassengerInfo[]>;
        getDocumentTypes();
    }

    class AddAPIService implements IAddAPIService {
        private documentTypes =  [
                    {
                        id: 1,
                        label: this.resourceService.getDeferred('PASSPORT')
                    },
                    {
                        id: 2,
                        label: this.resourceService.getDeferred('IDENTITYCARD')
                    }
            ];

         constructor(
            private $http: ng.IHttpService,
            private $q: ng.IQService,
            private resourceService: Core.ResourceService) {}

        getDocumentTypes() {
            return this.documentTypes;
        }

        addAPI(bookingId: number, passengers: PassengerInfo[]){
            return this.$http.post('/api/bookings/flights/apis/update', {
                BookingId: bookingId,
                PassengerInfo: passengers
            });
        }

        getAPI(bookingId: number): ng.IPromise<PassengerInfo[]>{
            return this.$http.get<PassengerInfo[]>('/api/bookings/flights/apis/get?' + $.param({
                BookingId : bookingId
            })).then(r => r.data);
        }

        getPassengers(bookingId: number): ng.IPromise<Passenger[]>{
            return this.$http.get<Passenger[]>(
                'api/bookings/myb/get?' + $.param({
                    bookingId : bookingId,
                    fields: 'passengers'
                })
            ).then(r => r.data.Passengers);
        }

        getPassengerInfo(bookingId: number): ng.IPromise<PassengerInfo[]>{
            return this.$q.all([
                this.getPassengers(bookingId),
                this.getAPI(bookingId)
            ]).then(([passengers, passengersFromAPI]) => {
                return passengers.map(p => {
                    const pa =  _.find(passengersFromAPI, (pa: PassengerInfo) => pa.PassengerId === p.Id);
                    let passenger = {
                        PassengerId: p.Id,
                        Name: `${p.Title} ${p.FirstName} ${p.SurName}`
                    };
                    if(pa) {
                        _.assign(passenger, {
                            DocumentNumber: pa.DocumentNumber,
                            Nationality: pa.Nationality,
                            DocumentIssuingCountry: pa.DocumentIssuingCountry,
                            CountryOfBirth: pa.CountryOfBirth,
                            DocumentType: pa.DocumentType,
                            DateOfBirth: pa.DateOfBirth,
                            DocumentIssuedDate: pa.DocumentIssuedDate,
                            DocumentExpiryDate: pa.DocumentExpiryDate,
                            DetailsSubmitted: true
                        });
                    }

                    return passenger;

                });
            });
        }
    }

    angular
        .module('dashboard')
        .service('addAPIService', AddAPIService);
}
